/* FIORELLE — interacciones y movimiento. Sin dependencias, se carga con defer. */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------ Scroll reveal ------- */
  /* Marca los elementos y activa .f-motion en <html> de inmediato (síncrono),
     para que el estado oculto exista antes del primer scroll. Si este script
     no corre, .f-motion nunca se añade y todo el contenido queda visible. */
  function markReveals() {
    if (reduceMotion) return;
    var root = document.documentElement;
    root.classList.add('f-motion');

    // Bloques que entran como una sola pieza (fade + rise).
    document
      .querySelectorAll('.f-head, .f-gift, .f-story__media, .f-story__body, .f-pdptrust')
      .forEach(function (el) {
        el.classList.add('f-reveal');
      });

    // Filetes oro: se "dibujan" (clip). Se excluyen los del hero (tienen su
    // propia entrada al cargar) para no gestionarlos dos veces.
    document.querySelectorAll('.f-rule').forEach(function (el) {
      if (el.closest('.f-hero')) return;
      el.classList.add('f-reveal', 'f-reveal--line');
    });

    // Grupos con entrada escalonada.
    var groups = [
      ['.f-cats', '.f-cat'],
      ['.f-reviews', '.f-review'],
      ['.f-trust__list', '.f-trust__item-wrap'],
      ['.f-story__points', '.f-story__point'],
      ['.f-rail__track', '.f-card'],
    ];
    groups.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (container) {
        var items = container.querySelectorAll(pair[1]);
        items.forEach(function (item, i) {
          item.classList.add('f-reveal');
          item.style.setProperty('--f-reveal-delay', Math.min(i, 8) * 0.07 + 's');
        });
      });
    });
  }

  function observeReveals() {
    if (reduceMotion) return;
    var targets = document.querySelectorAll('.f-reveal:not(.is-in)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------ Entrada del hero (load) --- */
  function initHero() {
    var content = document.querySelector('.f-hero__content');
    if (!content) return;
    if (reduceMotion) { content.classList.add('is-in'); return; }
    // Un frame de margen para asegurar la transición desde el estado oculto.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { content.classList.add('is-in'); });
    });

    // Parallax discreto de la imagen del hero (sólo escritorio, con puntero fino).
    var media = document.querySelector('.f-hero__media--desktop');
    if (!media || !window.matchMedia('(min-width: 750px)').matches) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = media.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          var shift = Math.max(-40, Math.min(40, rect.top * -0.08));
          media.style.transform = 'translate3d(0,' + shift + 'px,0)';
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------- Carrusel de producto --- */
  function initRails() {
    document.querySelectorAll('[data-f-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-f-rail-track]');
      var prev = rail.querySelector('[data-f-rail-prev]');
      var next = rail.querySelector('[data-f-rail-next]');
      if (!track || !prev || !next) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ----------------------------------- Barra de compra sticky (móvil) --- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-f-sticky]');
    var sentinel = document.querySelector('[data-f-sticky-anchor]');
    if (!bar || !sentinel) return;

    var wa = document.querySelector('[data-f-wa]');

    function toggle(show) {
      bar.classList.toggle('is-visible', show);
      if (wa) wa.classList.toggle('is-tucked', show);
    }

    if (!('IntersectionObserver' in window)) {
      // Sin soporte: la barra simplemente no aparece, el form original basta.
      return;
    }

    // Se muestra cuando el bloque de compra original ya salió por arriba.
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var pastIt = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          toggle(pastIt);
        });
      },
      { threshold: 0 }
    ).observe(sentinel);

    // El botón de la barra reenvía al form real para no duplicar lógica de carrito.
    var cta = bar.querySelector('[data-f-sticky-cta]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        var form = document.querySelector('product-form form[action*="/cart/add"]');
        if (!form) return; // deja que el enlace haga su trabajo
        e.preventDefault();
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.click();
      });
    }
  }

  /* --------------------------------- Mejora del selector de variante ----- */
  /* El catálogo nombra la opción "Color" con valores "ORO 18K" / "RODIO".
     No podemos editar el producto, así que mejoramos cómo se PRESENTA:
     la etiqueta pasa a decir "Baño", los valores se escriben en capitalización
     normal y cada opción gana un punto del metal correspondiente.
     Trabajamos sobre el picker nativo de Rise: no duplicamos lógica de carrito. */

  var METAL_LABELS = {
    'ORO 18K': 'Oro 18K',
    'ORO 18 K': 'Oro 18K',
    RODIO: 'Rodio',
    DORADO: 'Dorado',
    PLATEADO: 'Plateado',
  };

  function metalOf(value) {
    var v = value.toUpperCase();
    if (v.indexOf('ORO') > -1 || v.indexOf('DORAD') > -1 || v.indexOf('GOLD') > -1) return 'gold';
    if (v.indexOf('RODIO') > -1 || v.indexOf('PLAT') > -1 || v.indexOf('RHOD') > -1) return 'rhodium';
    return null;
  }

  function enhanceVariantPicker() {
    var picker = document.querySelector('variant-selects, variant-radios');
    if (!picker || picker.dataset.fEnhanced === '1') return;

    // "Color" describe mal un acabado de joyería. La marca lo llama "Baño".
    picker.querySelectorAll('legend, .form__label').forEach(function (el) {
      if (/(^|\s)color(\s|:|$)/i.test(el.textContent)) {
        el.innerHTML = el.innerHTML.replace(/color/i, 'Baño');
      }
    });

    picker.querySelectorAll('label').forEach(function (label) {
      var input = label.control || document.getElementById(label.htmlFor);
      var raw = (input && input.value) || label.textContent.trim();
      if (!raw) return;

      var metal = metalOf(raw);
      if (!metal) return;

      var pretty = METAL_LABELS[raw.toUpperCase().trim()];
      if (pretty) {
        // Sólo reemplazamos el nodo de texto: conservamos cualquier markup de Rise.
        label.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && node.textContent.trim()) node.textContent = ' ' + pretty;
        });
      }

      if (!label.querySelector('.f-metal')) {
        var dot = document.createElement('span');
        dot.className = 'f-metal f-metal--' + metal;
        dot.setAttribute('aria-hidden', 'true');
        dot.style.marginRight = '.7rem';
        dot.style.verticalAlign = 'middle';
        label.insertBefore(dot, label.firstChild);
      }
      label.style.display = 'inline-flex';
      label.style.alignItems = 'center';
    });

    picker.dataset.fEnhanced = '1';
  }

  /* --------------------------------- Progreso hacia el envío gratis ------- */
  function initShipMeter() {
    var meters = document.querySelectorAll('[data-f-ship]');
    if (!meters.length) return;

    function paint(cents) {
      meters.forEach(function (meter) {
        var threshold = parseInt(meter.getAttribute('data-f-ship'), 10);
        if (!threshold) return;
        var fill = meter.querySelector('[data-f-ship-fill]');
        var label = meter.querySelector('[data-f-ship-label]');
        var pct = Math.min(100, (cents / threshold) * 100);
        if (fill) fill.style.width = pct + '%';
        if (label && cents >= threshold) {
          label.textContent = label.getAttribute('data-f-ship-done') || label.textContent;
        }
      });
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) paint(cart.total_price); })
      .catch(function () { /* el bloque queda en su estado estático */ });
  }

  function boot() {
    observeReveals();
    initHero();
    initRails();
    initStickyAtc();
    enhanceVariantPicker();
    initShipMeter();
  }

  // Marcar el estado oculto lo antes posible, antes del boot, para evitar parpadeo.
  markReveals();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas recarga secciones sin recargar la página.
  document.addEventListener('shopify:section:load', function () {
    markReveals();
    boot();
  });
})();
